import { render, staticRenderFns } from "./Task4.vue?vue&type=template&id=33275f46&scoped=true&"
import script from "./Task4.vue?vue&type=script&lang=js&"
export * from "./Task4.vue?vue&type=script&lang=js&"
import style0 from "./Task4.vue?vue&type=style&index=0&id=33275f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33275f46",
  null
  
)

export default component.exports